import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import HeaderV2 from '../components/HeaderV2';
import RoastLabHeroV2 from './roast-lab/v2/RoastLabHeroV2';
import {
  RoastLabIntroV2,
  RoastLabCapacityV2,
  RoastLabProcessV2,
  RoastLabPricingV2,
} from './roast-lab/v2/RoastLabSectionsV2';
import { ROAST_LAB_CONTENT } from './roast-lab/v2/content';

const RoastLabPageV2: React.FC = () => {
  const location = useLocation();
  const lang: 'zh' | 'en' = location.pathname.startsWith('/en') ? 'en' : 'zh';
  const isZh = lang === 'zh';
  const isPreviewRoute = location.pathname.includes('/v2');

  useEffect(() => {
    const id = 'roastlab-v2-fonts';
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=EB+Garamond:wght@400;500&family=Noto+Serif+TC:wght@400;500&display=swap';
    document.head.appendChild(link);
  }, []);

  const { cta } = ROAST_LAB_CONTENT;
  const pageTitle = isZh ? '烘豆實驗室（V2 預覽）｜ONGU Studio' : 'Roast Lab (V2 Preview) - ONGU Studio';

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        {isPreviewRoute && <meta name="robots" content="noindex, nofollow" />}
        <link rel="canonical" href={`https://www.ongucoffee.com/${lang}/roast-lab`} />
      </Helmet>

      <div style={{ background: '#FAF9F1' }}>
        <HeaderV2 />
        <RoastLabHeroV2 isZh={isZh} />
        <RoastLabIntroV2 isZh={isZh} />
        <RoastLabCapacityV2 isZh={isZh} />
        <RoastLabProcessV2 isZh={isZh} />
        <RoastLabPricingV2 isZh={isZh} />

        {/* CTA */}
        <section className="bg-black text-white">
          <div className="max-w-[1280px] mx-auto px-6 lg:px-12 py-28 text-center">
            <h2
              className="mb-8 leading-[1.1]"
              style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400, fontSize: 'clamp(38px, 5vw, 76px)' }}
            >
              {isZh ? cta.heading.zh : cta.heading.en}
            </h2>
            <p className="text-base text-white/75 max-w-2xl mx-auto leading-[1.9] mb-12">
              {isZh ? cta.body.zh : cta.body.en}
            </p>
            <Link
              to={`/${lang}/wholesale`}
              className="inline-block px-12 py-4 border border-white text-xs tracking-[0.3em] uppercase hover:bg-white hover:text-black transition-colors"
            >
              {isZh ? '前往批發合作' : 'Go to Wholesale'}
            </Link>
          </div>
        </section>
      </div>
    </>
  );
};

export default RoastLabPageV2;
